import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Doughnut } from "react-chartjs-2";
import { FaRegFilePdf } from "react-icons/fa";
import { FaChartSimple } from "react-icons/fa6";
import { FaListUl } from "react-icons/fa";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import formatNumber from '../../../helpers/NumberFormat';
import Logo from '../../../assets/images/logo.png';
import "./BalanceSheet.scss"

export default function BalanceSheetComponent({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;
    const navigate = useNavigate();
    const balance = main?.user?.balance
    const allTransactions = main?.user?.transactions || [];
    const [charges, setCharges] = useState('doughnut');

    const exportPDF = () => {
        const doc = new jsPDF();

        const img = new Image();
        img.src = Logo;
        img.onload = () => {
            const pageWidth = doc.internal.pageSize.getWidth();
            const margin = 10;
            const logoWidth = 50;
            const logoHeight = 15;

            doc.setFontSize(16);
            doc.text(`Transaction Extract ${moment().format("DD/MM/YYYY")}`, margin, 20);

            const logoX = pageWidth - logoWidth - margin;
            const logoY = 10;
            doc.addImage(img, 'PNG', logoX, logoY, logoWidth, logoHeight);

            autoTable(doc, {
                startY: 30,
                head: [['Date', 'Amount', 'Beneficiary', 'Type', 'Status', 'Reference']],
                body: allTransactions.map(tx => [
                    moment(tx.execution_date).format("DD/MM/YYYY"),
                    formatNumber(tx.amount) + ' EUR',
                    tx.beneficary_name,
                    tx.type === 'out' ? 'Outgoing' : 'Incoming',
                    tx.status?.name ?? '',
                    tx.reference_code ?? '',
                ]),
            });

            doc.save('My-transactions.pdf');
        };
    };

    var options = {
        cutout: "60%",
        elements: {
            center: {
                color: "red",
                fontStyle: "Arial",
                sidePadding: 20,
                minFontSize: 20,
                lineHeight: 25,
            },
        },
        borderColor: "#FCFCFC",
    };
    const data = {
        labels: [],
        datasets: [
            {
                hoverOuterGlowWidth: "rgb(255, 255, 0)",
                label: "Balance €",
                data: [balance],
                backgroundColor: ["rgb(30,38,109)"],
                borderColor: ["#FCFCFC", "white"],
            },
        ],
    };

    return (
        <>
            <div
                className="container-fluid bg-col transition-width"
                style={
                    !isMobile
                        ? {
                            width: showSidebar ? 'calc(100% - 332px)' : '100%',
                            marginLeft: 0,
                            marginRight: 'auto',
                            transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                        } : {}
                }
            >
                <div className="row p-3 reports-panel">
                    <h5 className="mb-5 mt-2" style={{ fontWeight: "500" }}>BALANCE SHEET / CAPITAL POSITION</h5>
                    <p className='text-muted'>The values shown below are current as of <strong>{moment().format('D MMMM YYYY')}</strong>. Please be advised that any transactions processed after business hours or on non-business days may not yet be reflected.</p>


                    <div className='row mt-4 mb-5'>
                        <div className='col-md-6'>
                            <div
                                className={`bg-white shadow-sm w-100 rounded doughnut-wrapper h-auto mb-3${isMobile && "py-4"}`}
                            >
                                {" "}
                                <div className="text-start d-flex p-4 justify-content-between align-items-center">
                                    <div className="text-start d-flex justify-content-between">
                                        <h5 className="">Charges</h5>
                                        <FaListUl size={25} onClick={() => setCharges('table')} style={{ marginLeft: "20px", color: charges === 'table' ? "#6A343A" : "#a6acaf " }} />
                                        <FaChartSimple size={25} onClick={() => setCharges('doughnut')} style={{ marginLeft: "20px", color: charges === 'doughnut' ? "#6A343A" : "#a6acaf " }} />
                                    </div>
                                    <p
                                        onClick={() => navigate("/balance-and-movements")}
                                        type="button"
                                        className="text-grey "
                                    >
                                        Show More
                                    </p>
                                </div>
                                {charges === 'doughnut' ? (
                                    formatNumber(balance) ? (
                                        <>
                                            <div className="w-40 m-auto">
                                                <Doughnut
                                                    style={{
                                                        filter: `drop-shadow(0px 0px 2px red}`,
                                                    }}
                                                    data={data}
                                                    options={options}
                                                />
                                            </div>
                                            <div className="w-100 my-5">
                                                <div className={`d-flex border justify-content-start m-auto bg-light shadow ${isMobile ? "w-100" : "w80"}`}>
                                                    <div className="w-10 p-4">
                                                        <div className="outgoing-balance-sheet"></div>
                                                    </div>
                                                    <div className="w-90 d-flex justify-content-center">
                                                        <p className="available-liquidity">
                                                            <strong>Available liquidity: </strong> {formatNumber(balance)}€
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="w-100 m-1 p-1">
                                                {" "}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center mt-4 w-95 m-auto ">
                                            <h5 className="fw-bold">No Incoming Balance</h5>
                                        </div>
                                    )
                                ) : (
                                    <>
                                        <div className='p-2'>
                                            <table className="table table-xxl mt-2 border">
                                                <thead>
                                                    <tr className='table-head py-4'>
                                                        <th>Type</th>
                                                        <th className='text-end'>Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Available liquidity:</td>
                                                        <td className="text-end ">{formatNumber(balance)} €</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Total:</strong></td>
                                                        <td className="text-end "><strong>{formatNumber(balance)} €</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className={`col-md-6 py-4 ${isMobile && "mt-5"}`} >
                            <h5>SUMMARY DOCUMENT</h5>
                            <p>Download the complete document will all the data of your financial situation.</p>

                            <div className={`mt-5 ${isMobile ? "text-center" : "text-end"}`}>
                                <button className='btn rounded balaneCustom-bg-secondary' onClick={exportPDF}>
                                    <FaRegFilePdf style={{ fontSize: '30px' }} /> DOWNLOAD PDF
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </>
    );
}